import { AxiosRequestConfig } from 'axios';

const endpoint = '/api/file';

export default {
    getURLs: (id: number, path: string) =>
        ({ method: 'GET', url: `${endpoint}/${id}/urls`, params: { path } } as AxiosRequestConfig),
};
